import * as yup from "yup";

const isAtLeast18 = (value: Date | undefined): boolean => {
  if (!value) return false;
  const cutoff = new Date();
  cutoff.setFullYear(cutoff.getFullYear() - 18);
  return value <= cutoff;
};

export const PrequalificationSchema = yup.object({
  firstName: yup
    .string()
    .trim()
    .required("First name is required")
    .max(48, "First name must be 48 characters max.")
    .matches(/^[a-zA-Z ]*$/, "First name is not valid"),
  lastName: yup
    .string()
    .trim()
    .required("Last name is required")
    .max(48, "Last name must be 48 characters max.")
    .matches(/^[a-zA-Z ]*$/, "Last name is not valid"),
  email: yup
    .string()
    .trim()
    .lowercase()
    .email("Email must be a valid email")
    .required("Email is required"),
  phone: yup
    .string()
    .required("Mobile number is required")
    .matches(/^\d{3}-\d{3}-\d{4}$/, "Phone number must be exactly 10 digits")
    .min(12, "Phone number must be exactly 10 digits"),
  street: yup.string().trim().required("Street address is required"),
  city: yup.string().trim().required("City is required"),
  state: yup.string().required("State is required"),
  zip: yup
    .string()
    .required("Zip code is required")
    .matches(/^\d{5}(-\d{4})?$/, "Invalid zip code"),
  dateOfBirth: yup
    .date()
    .typeError("Date of birth is not valid")
    .required("Date of birth is required")
    .min(new Date(1900, 0, 1), "Date of birth is not valid")
    .test("isAdult", "You must be at least 18 years old", isAtLeast18),
  isAgreed: yup
    .boolean()
    .isTrue()
    .required(),
});

export type PrequalificationFormType = yup.InferType<typeof PrequalificationSchema>;
